<template>
  <div class="blog-feature">
    <UiComponentImage
      v-if="content.image"
      :alt="content.image.alt"
      :expected-size="imageSize"
      :height="content.image.height"
      :source="content.image.url"
      :width="content.image.width"
    />
    <div class="body">
      <UiComponentHeading
        as="paragraph"
        :level="4"
      >
        {{ content.title }}
      </UiComponentHeading>
      <UiComponentParagraph
        class="description"
        :level="4"
      >
        {{
          content.text
        }}
      </UiComponentParagraph>
      <AtomButton
        type="text"
        :action="content.button.action"
        :to="content.button.to"
      >
        {{ content.button.slot }} <UiComponentIcon type="arrow-right" />
      </AtomButton>
    </div>
  </div>
</template>

<script setup>
// Composables
const { width: screenWidth } = useScreenSize()

// Props
const props = defineProps({
  content: {
    default() {
      return {}
    },
    required: true,
    type: Object,
  },
})

// Computed Properties
const imageSize = computed(() => {
  return screenWidth.value < 768 ? screenWidth.value - 84 : 320
})
</script>

<style lang="postcss" scoped>
.blog-feature {
  @apply p-6 flex flex-col w-full border-2 border-grey-blue-200 rounded-4xl;

  @screen md {
    @apply flex-row items-center;
  }

  picture {
    @apply w-full h-full flex-shrink-0;
    border-radius: 16px;

    @screen md {
      @apply h-auto;
      width: 346px;
    }
  }

  .body {
    @apply flex flex-col;

    @screen md {
      @apply ml-10;
    }

    .h4 {
      @apply mt-6 text-winter-green-900 !important;

      @screen md {
        @apply mt-0;
      }
    }

    .description {
      @apply mt-4 text-sm text-grey-blue-600 leading-6;
    }

    .button {
      @apply mt-4 px-0 self-start h-[50px] font-bold text-livestorm-blue-700;

      i {
        @apply font-bold text-livestorm-blue-700;
      }
    }
  }
}
</style>
